<div [formGroup]="form">

    <!-- ── Identificação ─────────────────────────────────────────── -->
    <div class="section-container">

        <div class="row g-3 mb-3">
            <div class="col-12 col-md-3">
                <p class="field-label mb-2">Tipo de operação</p>
                <span class="campo-bloqueado-wrap"
                    matTooltip="O tipo de operação só pode ser definido na criação. Para usar outro tipo, crie ou duplique uma natureza."
                    [matTooltipDisabled]="!isEdicao">
                    <mat-radio-group formControlName="tipoOperacao" class="radio-group-inline">
                        @for (item of tiposOperacao; track item.id) {
                        <mat-radio-button [value]="item.id">{{ item.descricao }}</mat-radio-button>
                        }
                    </mat-radio-group>
                </span>
            </div>

            <div class="col d-flex align-items-end">
                <span matTooltip='Desmarque "Padrão para" para inativar a natureza.'
                    [matTooltipDisabled]="!form.get('isAtivo')?.disabled">
                    <mat-slide-toggle class="app-toggle-compact toggle-ativa" formControlName="isAtivo">
                        {{ form.get('isAtivo')?.value ? 'Ativa' : 'Inativa' }}
                    </mat-slide-toggle>
                </span>
            </div>
        </div>

        <div class="row g-3 mb-3">

            <div class="col-12 col-md-8">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="nome" maxlength="150" placeholder="Nome da natureza de operação">
                    @if (form.get('nome')?.hasError('required') && form.get('nome')?.touched) {
                    <mat-error>Nome é obrigatório.</mat-error>
                    }
                    @if (form.get('nome')?.hasError('maxlength')) {
                    <mat-error>Nome deve ter no máximo 150 caracteres.</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <span class="campo-bloqueado-wrap"
                    matTooltip="Ative a natureza para defini-la como padrão."
                    [matTooltipDisabled]="form.get('isAtivo')?.value !== false">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Padrão para</mat-label>
                        <mat-select formControlName="tiposPadrao" multiple placeholder="Nenhum">
                            @for (tipo of tiposPadraoDoTipoOperacao; track tipo.idTipoPadraoNaturezaOperacao) {
                            <mat-option [value]="tipo.idTipoPadraoNaturezaOperacao">{{ tipo.nome }}</mat-option>
                            }
                        </mat-select>
                        <mat-hint>{{ hintPadroes }}</mat-hint>
                    </mat-form-field>
                </span>
            </div>
        </div>

        <div class="row g-3 mb-3">

            <div class="col-12 col-md-4">
                <span class="campo-bloqueado-wrap"
                    matTooltip="O regime tributário só pode ser definido na criação. Para usar outro regime, crie ou duplique uma natureza."
                    [matTooltipDisabled]="!isEdicao">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Regime tributário</mat-label>
                        <mat-select formControlName="regimeTributario">
                            @for (item of regimes; track item.id) {
                            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                            }
                        </mat-select>
                        @if (form.get('regimeTributario')?.hasError('required') && form.get('regimeTributario')?.touched) {
                        <mat-error>Regime tributário é obrigatório.</mat-error>
                        }
                    </mat-form-field>
                </span>
            </div>

            <div class="col-12 col-md-2">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Finalidade</mat-label>
                    <mat-select formControlName="finalidadeNFe">
                        @for (item of finalidades; track item.id) {
                        <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <app-select-pesquisavel
                    [control]="emissorControl"
                    label="Emissor"
                    [offlineList]="emissoresOpcoes"
                    idField="idEmissor"
                    nameField="descricaoExibicao"
                    [isOptional]="true"
                    emptyOptionLabel="Nenhum - usar o emissor padrão"
                    placeholder="Nenhum - usar o emissor padrão"
                    subscriptSizing="dynamic"
                    [hint]="hintEmissor">
                </app-select-pesquisavel>
                @if (emissorSelecionado; as emissor) {
                <p class="small mt-1 mb-0 text-secondary">
                    Série {{ emissor.serie ?? '-' }} · Ambiente {{ descricaoAmbienteEmissor(emissor) }}{{ emissor.isTipoAmbienteAutomatico ? ' (Automático)' : '' }}
                </p>
                }
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>CFOP Padrão</mat-label>
                    <input matInput type="text" inputmode="numeric"
                        formControlName="cfopPadrao"
                        [mask]="masks.cfop" [patterns]="cfopPatterns"
                        [placeholder]="cfopPlaceholder"
                        (keydown)="onCfopKeydown($event)">
                    <button mat-icon-button matSuffix type="button"
                        matTooltip="Pesquisar CFOP"
                        (click)="pesquisarCfop()">
                        <mat-icon>search</mat-icon>
                    </button>
                    <mat-icon
                        matSuffix
                        [matTooltip]="cfopTooltipInfo"
                        matTooltipClass="cfop-tooltip"
                        matTooltipPosition="above">
                        info_outline
                    </mat-icon>
                    @if (cfopControl?.hasError('required') && cfopControl?.touched) {
                    <mat-error>CFOP é obrigatório.</mat-error>
                    }
                    @if (cfopControl?.hasError('cfopTipoInvalido') && cfopControl?.touched && !cfopControl?.hasError('required')) {
                    <mat-error>CFOP inválido para o tipo de operação selecionado.</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- ── Configurações avançadas ───────────────────────────────── -->
    <div class="section-container">
        <div class="section-title">
            <mat-icon>settings</mat-icon>
            <span>Configurações avançadas</span>
        </div>

        <div class="row g-3">

            <div class="col-12 col-md-6">
                <mat-slide-toggle class="app-toggle-compact" formControlName="consideraCmvDre">
                    Considerar CMV no DRE
                </mat-slide-toggle>
            </div>

            @if (tipoOperacaoValue === TipoOperacaoEnum.Entrada) {
            <div class="col-12 col-md-6">
                <mat-slide-toggle class="app-toggle-compact" formControlName="atualizaPrecoUltimaCompra">
                    Atualizar preço da última compra ao usar esta natureza
                </mat-slide-toggle>
            </div>
            }

            @if (tipoOperacaoValue === TipoOperacaoEnum.Saida) {
            <div class="col-12 col-md-6">
                <mat-slide-toggle class="app-toggle-compact" formControlName="consideraReceitaDre">
                    Considerar como receita no DRE
                </mat-slide-toggle>
            </div>
            }

        </div>
    </div>

</div>
